import PropTypes from "prop-types";
import React, { useState } from "react";
import { Box } from "@mui/material";
import { importSpreadsheet } from "../../../components/Api/Post";
import Papa from "papaparse";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}
CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

const tableOptions = [
	{
		name: "COURSE_STUDENT",
		value: "COURSE_STUDENT",
		type: "relationship",
	},
	{
		name: "COURSE_INSTRUCTOR",
		value: "COURSE_INSTRUCTOR",
		type: "relationship",
	},
];

export default function CSVUploads(props) {
	const { value, token } = props;

	const [csvData, setCsvData] = useState([]);
	const [headers, setHeaders] = useState([]);
	const [selectedOption, setSelectedOption] = useState("");
	const [loading, setLoading] = useState(false);
	const [importStatus, setImportStatus] = useState("");

	const handleFileUpload = (event) => {
		const file = event.target.files[0];

		if (file) {
			Papa.parse(file, {
				header: true,
				skipEmptyLines: true,
				complete: (result) => {
					// Extracting headers and data
					setHeaders(Object.keys(result.data[0] || {}));
					setCsvData(result.data);
				},
				error: (error) => {
					console.error("Error reading CSV file:", error);
				},
			});
		}
	};

	const handleSelectChange = (event) => {
		setSelectedOption(event.target.value);
	};

	const handleImport = async () => {
		const data = {
			table: selectedOption,
			data: csvData,
		};

		try {
			setLoading(true);
			setImportStatus("Importing spreadsheet, please wait...");
			const response = await importSpreadsheet(token, data);
			if (response.status === 200) {
				setLoading(false);
				setImportStatus("Spreadsheet imported successfully");
			}
		} catch (error) {
			setLoading(false);
			setImportStatus("Error importing spreadsheet", error);
			console.error(error);
		}
	};

	return (
		<CustomTabPanel
			value={value}
			index={1}
		>
			<div className="w-full flex flex-col items-center justify-center mt-8 pb-10">
				<div>{importStatus}</div>
				<input
					className="border-2 rounded-md px-4 py-2 bg-gray-100 text-black border-green-800 mb-4"
					type="file"
					accept=".csv"
					onChange={handleFileUpload}
				/>

				<select
					value={selectedOption}
					onChange={handleSelectChange}
					className="mb-4 px-4 py-2 border border-gray-400 rounded-md text-gray-700"
				>
					<option
						value=""
						disabled
					>
						Select Table Option
					</option>
					{tableOptions.map((option) => (
						<option
							key={option.value}
							value={option.value}
						>
							{option.name}
						</option>
					))}
				</select>

				{selectedOption && (
					<button
						onClick={handleImport}
						disabled={loading || csvData.length === 0}
						className={`${
							loading || csvData.length === 0
								? " bg-gray-500 text-black border-gray-800 hover:cursor-not-allowed"
								: "bg-green-700 hover:bg-green-800 text-white border-green-800"
						}border-2 rounded-md px-4 py-2   `}
					>
						Import {csvData.length} rows Into {selectedOption}
					</button>
				)}

				{headers.length > 0 && csvData.length > 0 && (
					<div className="mt-4 max-h-[60dvh] overflow-y-auto w-[50dvw] ">
						<table className="table-auto border-collapse border border-gray-400 w-full">
							<thead>
								<tr>
									{headers.map((header, index) => (
										<th
											key={index}
											className="border border-gray-400 px-4 py-2"
										>
											{header}
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{csvData.map((row, rowIndex) => (
									<tr key={rowIndex}>
										{headers.map((header, index) => (
											<td
												key={index}
												className="border border-gray-400 px-4 py-2"
											>
												{row[header]}
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</CustomTabPanel>
	);
}
